export default "__VITE_ASSET__auXT6WZv__"